// Dashboard user roles. A user can hold several roles; access is granted when
// any of them is allowed.
export const ROLE_OPTIONS = [
  {
    value: "Admin",
    label: "Admin",
    description: "All Permissions",
    color: "#007530",
  },
  {
    value: "DataEntry",
    label: "Data Entry",
    description: "Add Product /Category /News /Activities /Pages",
    color: "#cc4125",
  },
  {
    value: "Messaging",
    label: "Messaging",
    description: "Messaging Center",
    color: "#e06666",
  },
  {
    value: "HR",
    label: "HR",
    description: "Career Center",
    color: "#ff9900",
  },
  {
    value: "Sales",
    label: "Sales",
    description: "Orders",
    color: "#4a86e8",
  },
];

const ROLE_VALUES = ROLE_OPTIONS.map((option) => option.value);

// Keeps valid roles only, without duplicates, in ROLE_OPTIONS order.
export const normalizeRoles = (roles) => {
  const list = Array.isArray(roles) ? roles : roles ? [roles] : [];
  return ROLE_VALUES.filter((role) => list.includes(role));
};

// Roles of a dashboard user record (from /users/allusers).
export const getRolesOfUser = (user) => {
  const roles = normalizeRoles(user?.roles);
  return roles.length ? roles : normalizeRoles(user?.role);
};

// Roles of the logged-in user. The login payload is [token, role, user];
// sessions saved before multi-role support only have the single role.
export const getUserRoles = (currentUser) => {
  const payload = currentUser?.user;
  const roles = normalizeRoles(payload?.[2]?.roles);
  return roles.length ? roles : normalizeRoles(payload?.[1]);
};

export const hasRole = (roles, allowedRoles) =>
  (roles || []).some((role) => allowedRoles.includes(role));

export const primaryRole = (roles) =>
  roles.includes("Admin") ? "Admin" : roles[0];
